export default __webpack_public_path__ + "static/media/dtch-qr.5d1fc769.svg";